module.exports = __webpack_public_path__ + "static/media/lumbering14.53a5afe4.jpg";